<template>
    <div id="listEnquiry">
        <!-- <div id="page-content-wrapper" class="admin-content-area"> -->
            <template v-if="cantAccessPage === true">
                <customer id="customerList" :customerReportVal="value"></customer>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
        <!-- </div>   -->
    </div>
</template>

<script>
    import Vue from "vue";
    import EventBus from ".././event-bus";
    import {commonMixins} from '../../mixins/commonMixins';
    
    
    import CustomerList from '@/components/CustomerList';
    Vue.component("customer", CustomerList);

    var contex

    export default {
        name: "unsyncCustomer",
        mixins:[commonMixins],
        data: () => ({
            value:"registerreport",
            cantAccessPage:"",
            permissions:[],
            loading: false,

        }),

        watch:{
            permissions: function(permission){
                var self = this;
                permission.forEach(function (permissions) {
                    if(permissions.name == 'list_unsync_data') {
                        self.cantAccessPage = true;
                    }
                });
                if(self.cantAccessPage == ''){
                    self.cantAccessPage = false;
                }
            }
        },

        beforeMount: function() {
            contex = this;
        },

        mounted: function () {

            var self = this;
            EventBus.$emit("profile", false);

            self.getPermissions();


        },

    };

</script>
<style scoped>
    /*#tableFlow{*/
    /*overflow-y: auto;*/
    /*}*/
</style>




// WEBPACK FOOTER //
// src/components/reports/CustomerRegisterReport.vue